// Business slider initialization using Swiper (module imports compatible with Vite/Rollup)
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export function initBusinessSwiper() {
  if (!document.querySelector('.business-slide')) return;

  new Swiper('.business-slide', {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    centeredSlides: false,
    initialSlide: 0,
    // touch / swipe options
    touchRatio: 1,
    simulateTouch: true,
    allowTouchMove: true,
    grabCursor: true,
    touchStartPreventDefault: false,
    // spaceBetween: 20,
    loop: false,
    pagination: {
		el: '.business-slide .swiper-pagination',
		clickable: true,
    },
    // navigation: {
	// 	nextEl: '.business-slide .swiper-button-next',
	// 	prevEl: '.business-slide .swiper-button-prev',
    // },
    breakpoints: {
		375: { slidesPerView: 1.2 },
		640: { slidesPerView: 1.5 },
		1024: { slidesPerView: 1.7 },
    },
  });
}
